// the arrays have to be sorted in order for isEqual to work
export default {
    traffic: {
        type: ['Baustelle', 'CAMERA', 'Schneeketten', 'Sperren', 'Verkehrsbehinderungen', 'Verkehrsfluss'],
        other: {
            favouritesOnly: false,
        },
    },
    gasStations: {
        fuels: ['DIESEL'], // even though the field is single-choice - the api expects an array. SmrSelect can handle that and also returns an array with single value.
        operator: [],
        operationMode: '',
        services: [],
        other: {
            openNextHour: false,
            openAllDay: false,
            oeamtcPartner: false,
            favouritesOnly: false,
        }
    },
    chargingStations: {
        capacity: [0, 500],
        plugTypes: [ "CCS_TYP2", "CEE_THREE_POLE", "CHA_DE_MO", "SCHUKO_PLUG", "TYP1", "TYP2", "UNKNOWN"],
        other: {
            openNextHour: false,
            openAllDay: false,
            oeamtcEPower: false,
            favouritesOnly: false,
            free: false,
            greenEnergy: false,
        }
    },
    nearbyStations: {
        radius: 5000,
        other: {
            favouritesOnly: false,
        },
    },
    travelRadar: {
        country: [],
    },
    sights: {
        categories: ['BUILDING', 'RESTAURANT', 'MUSEUM', 'TOURIST_INFORMATION', 'NATURE', 'AIRPORT', 'ENTERTAINMENT', 'TRAIN_STATION'],
        other: {
            favouritesOnly: false,
        },
    },
    carParks: {
        categories: ['OPEN_SPACE', 'PARK_AND_RIDE', 'PARK_AND_DRIVE', 'PARKING_GARAGE', 'SHORTTERMPARKING'],
        priceMode: 'PER_HOUR',
        operator: [],
        other: {
            openNextHour: false,
            openAllDay: false,
            oeamtcPartner: false,
            accessible: false,
            favouritesOnly: false,
        }
    },
    oeamtcLocations: {
        categories: ['BASE', 'BICYCLE_STATION', 'BORDER_STATION', 'CHRISTOPHORUS_BASE', 'DRIVING_SKILLS_CENTER', 'MOBILITY_PARK', 'STATE_CLUB', 'TRAVEL_AGENCY'],
        other: {
            openNextHour: false,
            favouritesOnly: false,
        },
    },
    partners: {
        categories: ['ACCOMMODATION', 'ENTERTAINMENT', 'GASTRONOMY', 'LEISURE', 'MOBILITY', 'SHOPPING', 'SPORTS'],
        other: {
            openNextHour: false,
            favouritesOnly: false,
        },
    },
    favourites: {
        uncheckedLists: [],
        uncheckedCategories: [],
    },
    camping: {
        categories: ['CAMPER', 'CAMPING', /*'OECC'*/],
        other: {
            openNextHour: false,
            favouritesOnly: false,
        },
    },
    tollRoads: {
        roadConnection: {
            suitableForCampers: false,
            openAllYear: false,
        },
        other: {
            favouritesOnly: false,
        },
    },
    passRoads: {
        roadConnection: {
            suitableForCampers: false,
            openAllYear: false,
        },
        other: {
            favouritesOnly: false,
        },
    },
    roadHouses: {
        facility: {
            changingTable: false,
            playground: false,
        },
        other: {
            openNextHour: false,
            openAllDay: false,
            oeamtcPartner: false,
            accessible: false,
        }
    }
}